module.exports = __webpack_public_path__ + "static/how-it-works-1-c0786db75206cf3d129f25475d1c9c3f.png";